import { AppState } from '../../../../app.reducers';
import { Store } from '@ngrx/store';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { getAuthState } from '../../../../shared/auth/redux/auth.selectors';
import { AccountService, CustomValidators } from '../../../../shared';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AuthState } from '../../../../shared/auth/redux/auth.state';
import { SubSink } from 'subsink';
import { ToastrService } from 'ngx-toastr';

@Component({
  templateUrl: './change-password.html',
  standalone: false
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  @ViewChild('currentPassword', { static: true }) currentPasswordInput;
  showTypingText = 'show typing';

  feedbackMessages: any[] = [];
  successMessage = '';
  pageForm: UntypedFormGroup;
  isSubmitting = false;

  private subs = new SubSink();

  constructor(private router: Router,
    private store: Store<AppState>,
    private accountService: AccountService,
    private toastr: ToastrService) {
  }

  ngOnInit() {
    this.initForms();

    this.subs.sink = this.store
      .select(getAuthState)
      .subscribe((authState: AuthState) => {
        if (authState.loggedIn !== true) {
          this.goToMain();
        }
      });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  showCurrentPassword(e) {

    const inputType =
            this.currentPasswordInput.nativeElement.type;

    if (inputType === 'password') {
      this.currentPasswordInput.nativeElement.type = 'text';
      this.showTypingText = 'hide typing';
    } else {
      this.currentPasswordInput.nativeElement.type = 'password';
      this.showTypingText = 'show typing';
    }
  }

  onChangePassword() {
    this.isSubmitting = true;
    this.subs.sink = this.changePassword()
      .subscribe(() => {
        this.pageForm.reset();

        this.isSubmitting = false;

        this.toastr.success('Password Changed');
        this.goToMain();

      }, (error) => this.handleError(error));
  }

  changePassword() {
    this.successMessage = '';
    this.feedbackMessages = [];

    const payload = {
      email: this.pageForm.value.email,
      currentPassword: this.pageForm.value.currentPassword,
      newPassword: this.pageForm.value.newPassword,
      confirmPassword: this.pageForm.value.confirmPassword,
    };

    return this.accountService.changePassword(payload);
  }

  private goToMain() {
    this.router.navigate(['useraccount/user/profile']);
  }

  private initForms() {
    this.pageForm = new UntypedFormGroup({
      email: new UntypedFormControl(),
      currentPassword: new UntypedFormControl(),
      newPassword: new UntypedFormControl(),
      confirmPassword: new UntypedFormControl()
    });

    const newPassword = this.pageForm.controls['newPassword'];
    const confirmPassword = this.pageForm.controls['confirmPassword'];

    newPassword.setValidators(Validators.compose([Validators.required,
      CustomValidators.passwordPolicy(newPassword)]));

    confirmPassword.setValidators(Validators.compose([Validators.required,
      CustomValidators.equal(newPassword)]));

    this.subs.sink = newPassword.valueChanges.subscribe(() => confirmPassword.updateValueAndValidity());
  }

  private handleError(errors) {
    this.isSubmitting = false;
    this.feedbackMessages = errors;
  }
}
